/**
 * 校验
 * @param {object} target 目标
 */
export const validate = (requestIds) => {
  if (!requestIds || !Array.isArray(requestIds)) {
    return {
      success: false,
      errorMsg: `requestIds:${requestIds} 须为列表`,
    };
  }

  return {
    success: true,
    errorMsg: "",
  };
};

export const runtimeValidate = (requestId, request) => {
  if (request && typeof request.func === "function") {
    return {
      success: true,
      errorMsg: "",
    };
  }
  return {
    success: false,
    errorMsg: `requestId:${requestId}没有对应的Request`,
  };
};

/**
 * 解析并行处理的 requestIds
 * @param {string} requestIds 目标requestIds
 * @return {object} { owner }
 */
export const parse = (requestIds, options = {}) => {
  const { owner } = options;

  return {
    handler: ({ initial } = {}) => {
      if (!requestIds || !Array.isArray(requestIds)) {
        return;
      }
      requestIds.forEach((requestId) => {
        const request = owner.listenersMap && owner.listenersMap[requestId];
        const runtimeValidateResult = runtimeValidate(requestId, request);
        console.warn(
          runtimeValidateResult.success,
          runtimeValidateResult.errorMsg
        );
        runtimeValidateResult.success && request.func({ initial });
      });
    },
  };
};
